import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const SubSectionHeader = styled('h3')`
  ${({ theme }) => theme.typography.largeStrong}
  color: ${(props) => props.theme.color.whiteRGBA(0.5)};
  margin: 0 0 ${({ theme }) => theme.x1spacePx}px;

  body[data-theme] & {
    color: var(--s-color-text-softer);
  }

  ${media.lgUp`
    color: ${(props) => props.theme.color.white};
    body[data-theme] & {
        color: var(--s-color-text-solid);
    }
  `}
`;
